// ProgressBar — single bar with right-aligned label, terminal aesthetic.

interface Props {
  done: number;
  total: number;
  label?: string;
}

export function ProgressBar({ done, total, label }: Props) {
  const pct = total === 0 ? 0 : Math.min(1, done / total);
  return (
    <div className="shukan-progress" role="progressbar" aria-valuemin={0} aria-valuemax={total} aria-valuenow={done}>
      <div
        className="shukan-progress-fill"
        style={{ transform: `scaleX(${pct})` }}
      />
      <div className="shukan-progress-label">
        {label ?? `${done}/${total}  ${(pct * 100).toFixed(0)}%`}
      </div>
    </div>
  );
}
